import React from 'react';
import { InstagramIcon, FacebookIcon, PhoneIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-cream border-t border-divider py-12 md:py-16" data-id="element-132">
      <div className="container mx-auto px-4 md:px-6" data-id="element-133">
        <div className="flex flex-col items-center text-center" data-id="element-134">
          <div className="mb-8" data-id="element-135">
            <span className="font-serif text-2xl font-medium tracking-tight text-primary" data-id="element-136">
              Be Clinical
            </span>
            <p className="text-foreground/60 text-sm mt-2" data-id="element-137">San Ramon, CA</p>
          </div>

          <nav className="mb-8 w-full" data-id="element-138">
            <ul className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8" data-id="element-139">
              {['Services', 'About', 'Results', 'FAQ', 'Contact'].map(item => <li key={item} data-id="element-140">
                    <a href="#" className="text-sm font-medium text-foreground/70 hover:text-gold transition-colors" data-id="element-141">
                      {item}
                    </a>
                  </li>)}
            </ul>
          </nav>

          <div className="flex items-center justify-center gap-6 mb-10" data-id="element-142">
            <a href="#" className="text-foreground/40 hover:text-gold transition-colors" aria-label="Instagram" data-id="element-143">
              <InstagramIcon size={20} data-id="element-144" />
            </a>
            <a href="#" className="text-foreground/40 hover:text-gold transition-colors" aria-label="Facebook" data-id="element-145">
              <FacebookIcon size={20} data-id="element-146" />
            </a>
            <a href="#" className="text-foreground/40 hover:text-gold transition-colors" aria-label="Phone" data-id="element-147">
              <PhoneIcon size={20} data-id="element-148" />
            </a>
          </div>

          <div className="text-xs text-foreground/40 flex flex-col md:flex-row items-center gap-2 md:gap-4" data-id="element-149">
            <p data-id="element-150">
              &copy; {currentYear} Be Clinical San Ramon. All rights reserved.
            </p>
            <span className="hidden md:inline" data-id="element-151">|</span>
            <div className="flex gap-4" data-id="element-152">
              <a href="#" className="hover:text-foreground/70 transition-colors" data-id="element-153">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-foreground/70 transition-colors" data-id="element-154">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}